import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../../../store/index';
import { archive, changeActiveFrame, TRemoveModalFrame } from '../../../../../store/popups/remove';
import { Archive, IArchiveProps } from './index';

type TStoreProps = Pick<IArchiveProps, 'agent' | 'isByHomeowner' | 'offerId' | 'status'>;
type TDispatchProps = Pick<IArchiveProps, 'changeActiveFrame' | 'onSubmit'>;

function mapStateToProps(state: IState): TStoreProps {
  return {
    agent: state.offerData.agent,
    isByHomeowner: state.offerData.offer.isByHomeowner,
    offerId: state.pageData.offerId,
    status: state.remove.status,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): TDispatchProps {
  return {
    changeActiveFrame: (newActiveFrame: TRemoveModalFrame) => dispatch(changeActiveFrame(newActiveFrame)),
    onSubmit: () => dispatch(archive()),
  };
}

export const ArchiveContainer = connect<TStoreProps, TDispatchProps, {}>(mapStateToProps, mapDispatchToProps)(Archive);
